import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "data", "icons"];
import { forwardRef, Fragment, useContext } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled from 'styled-components';
import Icon from '../../Icon';
import Link from '../../Link';
import Popover from '../../Popover';
import { CardContext } from '../Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTitle = styled.div.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-1qxhv25-0"
})(["color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-20);font-weight:", ";line-height:var(--dentsu-leading-tight);margin:0 0 ", ";display:flex;align-items:center;.", "-card--editorial &{text-align:center;justify-content:center;}+ .", "-card__metadata{margin-top:0;}.", "-icon{color:var(--dentsu-color-blue);margin-left:var(--dentsu-spacing-8);vertical-align:unset;}"], function (props) {
  return props.variant === 'list' ? 'var(--dentsu-font-weight-regular)' : 'var(--dentsu-font-weight-bold)';
}, function (props) {
  return props.variant === 'list' ? 'var(--dentsu-spacing-4)' : 'var(--dentsu-spacing-8)';
}, prefix, prefix, prefix);
var StyledIcons = styled.div.withConfig({
  displayName: "Title__StyledIcons",
  componentId: "sc-1qxhv25-1"
})(["display:flex;align-items:center;margin-left:var(--dentsu-spacing-4);.", "-icon{color:var(--dentsu-color-n350);margin-left:var(--dentsu-spacing-8);vertical-align:unset;}"], prefix);
var StyledPopoverContent = styled.div.withConfig({
  displayName: "Title__StyledPopoverContent",
  componentId: "sc-1qxhv25-2"
})(["font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-regular);padding:var(--dentsu-spacing-4) var(--dentsu-spacing-12);.", "-link{font-size:var(--dentsu-font-size-12);}"], prefix);
var Title = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      dataFromProps = _ref.data,
      iconsfromProp = _ref.icons,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-card__title"), true));

  var _useContext = useContext(CardContext),
      variant = _useContext.variant;

  var icons = (dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.icons) || iconsfromProp;
  return _jsxs(StyledTitle, {
    ref: ref,
    className: className,
    variant: variant,
    children: [(dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.label) || children, icons && _jsx(StyledIcons, {
      children: icons.map(function (item, index) {
        var _item$tooltip, _item$tooltip$placeme, _item$tooltip2, _item$tooltip3, _item$tooltip4, _item$tooltip5, _item$icon;

        var hasTooltip = item === null || item === void 0 ? void 0 : item.tooltip;
        var hasUrl = item === null || item === void 0 ? void 0 : (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.url;
        return _jsxs(Fragment, {
          children: [hasTooltip && _jsxs(Popover, {
            variant: "tooltip",
            trigger: "mouseenter",
            placement: (_item$tooltip$placeme = (_item$tooltip2 = item.tooltip) === null || _item$tooltip2 === void 0 ? void 0 : _item$tooltip2.placement) !== null && _item$tooltip$placeme !== void 0 ? _item$tooltip$placeme : 'auto',
            isPadded: false,
            children: [_jsx(Popover.Trigger, {
              children: _jsx(Icon, {
                size: 12,
                color: "var(--dentsu-color-n650)",
                icon: item === null || item === void 0 ? void 0 : item.icon
              })
            }), _jsx(Popover.Content, {
              children: _jsxs(StyledPopoverContent, {
                children: [hasUrl && _jsx(Link, {
                  isMonochrome: true,
                  isExternal: true,
                  url: (_item$tooltip3 = item.tooltip) === null || _item$tooltip3 === void 0 ? void 0 : _item$tooltip3.url,
                  children: (_item$tooltip4 = item.tooltip) === null || _item$tooltip4 === void 0 ? void 0 : _item$tooltip4.content
                }), !hasUrl && ((_item$tooltip5 = item.tooltip) === null || _item$tooltip5 === void 0 ? void 0 : _item$tooltip5.content)]
              })
            })]
          }), !hasTooltip && _jsx(Icon, {
            size: 12,
            color: "var(--dentsu-color-n650)",
            icon: (_item$icon = item === null || item === void 0 ? void 0 : item.icon) !== null && _item$icon !== void 0 ? _item$icon : null
          })]
        }, index);
      })
    })]
  });
});
export default Title;